<script setup lang="ts">
import InfoModal from "@/components/Common/InfoModal.vue"
import { computed } from "vue"
import i18n from "@/lang/i18n"

const props = defineProps<{
  modelValue: boolean
  duplicateModalExec: () => void
}>()

const emit = defineEmits(['update:modelValue'])
const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})
</script>
<template>
  <InfoModal
    v-model="modelValue"
    modalWidth="40%"
    :title="i18n.global.t('common.confirmationModal.title')"
  >
    <template v-slot:text>
      <v-row>
        {{ i18n.global.t('pages.roleAssignment.modal.duplicationConfirm.row1') }}
      </v-row>
      <v-row>
        {{ i18n.global.t('pages.roleAssignment.modal.duplicationConfirm.row2') }}
      </v-row>
    </template>
    <template v-slot:footer>
      <div class="d-flex w-100 justify-content-end mb-4 pr-6">
        <v-btn
          class="close-btn"
          @click="modelValue = false"
        >
          {{ i18n.global.t('common.closeBtn') }}
        </v-btn>
        <v-btn
          class="exec-btn ml-2"
          @click="props.duplicateModalExec"
        >
          {{ i18n.global.t('pages.common.button.exec') }}
        </v-btn>
      </div>
    </template>
  </InfoModal>
</template>